import React from 'react';
import ReactDOM from 'react-dom';
import Navbar from './components/NavBar';
import Footer from './components/Footer';
import '../styles/wordpress.scss';

const headerNode = document.getElementById('cccisd-header');
if (headerNode) {
    ReactDOM.render(<Navbar />, headerNode);
}

const footerNode = document.getElementById('cccisd-footer');
if (footerNode) {
    ReactDOM.render(<Footer />, footerNode);
}
